import app from 'flarum/forum/app';

/**
 * The floating "Edit theme" button shown to admins (and members who may
 * personalise their own view). The editor (panels, inspector, sortablejs and its
 * stylesheet) is a separate chunk fetched on the first click, so nobody — not
 * even an admin who never opens it — downloads it with the page.
 *
 * Visibility is route-aware: it must NOT show on Page Builder pages (whose own
 * in-context editor owns those pages) — editing the Bespoke theme there makes no
 * sense, since Page Builder renders its own layout. `refresh()` is called from a
 * Page.oncreate hook on every navigation and shows/hides accordingly.
 */
export default class BespokeLauncher {
  static attached = false;

  /** Can the current actor open the editor at all? */
  static permitted() {
    return !!(app.forum?.attribute('bespokeCanEdit') || app.forum?.attribute('bespokeCanCustomize'));
  }
  static attach() {
    if (this.attached || document.getElementById('bespoke-launcher')) return;
    const btn = document.createElement('button');
    btn.id = 'bespoke-launcher';
    btn.innerHTML = '✦ ' + app.translator.trans('ernestdefoe-bespoke.forum.launcher');
    btn.onclick = () => import(/* webpackChunkName: 'forum/components/BespokeEditor', webpackMode: 'lazy-once' */ './BespokeEditor').then(mod => mod.default.open());
    document.body.appendChild(btn);
    this.attached = true;
  }
  static setVisible(visible) {
    const btn = document.getElementById('bespoke-launcher');
    if (btn) btn.style.display = visible ? '' : 'none';
  }

  /**
   * Show the launcher on Bespoke-themed pages, hide it on Page Builder pages.
   * @param routeName the active route name (Page.attrs.routeName).
   */
  static refresh(routeName) {
    if (!this.permitted()) return; // visitor / no permission — never attach
    if (!this.attached) this.attach();
    // Page Builder registers all its routes under the `pagebuilder.*` namespace
    // (incl. the forum home when set as the default page). Hide there.
    const onPageBuilder = typeof routeName === 'string' && routeName.indexOf('pagebuilder') === 0;
    this.setVisible(!onPageBuilder);
  }
}
flarum.reg.add('ernestdefoe-bespoke', 'forum/components/BespokeLauncher', BespokeLauncher);flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/BespokeEditor');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/inspect');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/PalettePanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/TypographyPanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/ShapePanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/LayoutPanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/HeroPanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/DiscussionPanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/EffectsPanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/SitePanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/WidgetsPanel');
flarum.reg.addChunkModule('ernestdefoe-bespoke:forum/components/BespokeEditor', '828', 'ernestdefoe-bespoke', 'forum/components/panels/PresetsPanel');